import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownOnSquare = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 1.5C12.4142 1.5 12.75 1.83579 12.75 2.25V13.1893L14.4697 11.4697C14.7626 11.1768 15.2374 11.1768 15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L8.46967 12.5303C8.17678 12.2374 8.17678 11.7626 8.46967 11.4697C8.76256 11.1768 9.23744 11.1768 9.53033 11.4697L11.25 13.1893V2.25C11.25 1.83579 11.5858 1.5 12 1.5ZM5.37868 8.37868C5.94129 7.81607 6.70435 7.5 7.5 7.5H9C9.41421 7.5 9.75 7.83579 9.75 8.25C9.75 8.66421 9.41421 9 9 9H7.5C7.10218 9 6.72064 9.15804 6.43934 9.43934C6.15804 9.72064 6 10.1022 6 10.5V19.5C6 19.8978 6.15804 20.2794 6.43934 20.5607C6.72064 20.842 7.10218 21 7.5 21H16.5C16.8978 21 17.2794 20.842 17.5607 20.5607C17.842 20.2794 18 19.8978 18 19.5V10.5C18 10.1022 17.842 9.72064 17.5607 9.43934C17.2794 9.15804 16.8978 9 16.5 9H15C14.5858 9 14.25 8.66421 14.25 8.25C14.25 7.83579 14.5858 7.5 15 7.5H16.5C17.2956 7.5 18.0587 7.81607 18.6213 8.37868C19.1839 8.94129 19.5 9.70435 19.5 10.5V19.5C19.5 20.2957 19.1839 21.0587 18.6213 21.6213C18.0587 22.1839 17.2956 22.5 16.5 22.5H7.5C6.70435 22.5 5.94129 22.1839 5.37868 21.6213C4.81607 21.0587 4.5 20.2957 4.5 19.5V10.5C4.5 9.70435 4.81607 8.94129 5.37868 8.37868Z",
		fill: "currentcolor"
	})]
});
export default SvgArrowDownOnSquare;
